import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import LogicaAPI from "./logicaapi";

var Right = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(Right, _LogicaAPI);

  var _super = _createSuper(Right);

  function Right() {
    _classCallCheck(this, Right);

    return _super.apply(this, arguments);
  }

  _createClass(Right, [{
    key: "courses",
    value: function () {
      var _courses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.get("/api/v1/rights/".concat(id, "/courses")));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function courses(_x) {
        return _courses.apply(this, arguments);
      }

      return courses;
    }()
  }, {
    key: "products",
    value: function () {
      var _products = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.get("/api/v1/rights/".concat(id, "/products")));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function products(_x2) {
        return _products.apply(this, arguments);
      }

      return products;
    }() // 本番環境だとrightのスキーマに画像が設定されていてLogicaAPIが500エラーになるので使わない
    // async productRights(productId) {
    //   return this.get(`/products/${productId}/rights`);
    // }

  }, {
    key: "rightsByRefId",
    value: function () {
      var _rightsByRefId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(refId) {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.get("/api/v1/rights?id=ref:".concat(refId));

              case 2:
                res = _context3.sent;
                return _context3.abrupt("return", res === null || res === void 0 ? void 0 : res[0]);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function rightsByRefId(_x3) {
        return _rightsByRefId.apply(this, arguments);
      }

      return rightsByRefId;
    }()
  }, {
    key: "rightsByIds",
    value: function () {
      var _rightsByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ids) {
        var idString;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // ids : array of int
                idString = ids.join(",");
                return _context4.abrupt("return", this.get("/api/v1/rights?id=".concat(idString)));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function rightsByIds(_x4) {
        return _rightsByIds.apply(this, arguments);
      }

      return rightsByIds;
    }()
  }]);

  return Right;
}(LogicaAPI);

export default Right;